import { DashboardProvider } from './context/dashboardContext';
import Dashboard from './pages/dashboard.js';
import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {

	return (
		<DashboardProvider>
			<Dashboard />
		</DashboardProvider>
	);
}

export default App;
